
    import './styles.scoped.css';
    export default {
  "toggle": "_toggle_bhe8t_3",
  "description": "_description_bhe8t_32"
};
  